import { render, staticRenderFns } from "./JalanIrigasiJaringanPage.vue?vue&type=template&id=44ed74e5"
import script from "./JalanIrigasiJaringanPage.vue?vue&type=script&lang=js"
export * from "./JalanIrigasiJaringanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports